import * as React from "react";
import {Fragment} from "react";
import Aside from "../Aside/Aside";
import FetchData from "../../backend/FetchData";
import CopyToClipboard from "../../CopyToClipboard";

class Import extends React.Component {

	constructor(props) {
		super(props);
		this.state = {
			error: false,
			imported: false,
		}
		this.char1 = React.createRef();
		this.char2 = React.createRef();
		this.char3 = React.createRef();
		this.char4 = React.createRef();
		this.char5 = React.createRef();
		this.char6 = React.createRef();
		this.handleChange = this.handleChange.bind(this);
		this.fetchConfiguration = this.fetchConfiguration.bind(this);
		this.importConfiguration = this.importConfiguration.bind(this);
	}

	handleChange(el) {
		let value = el.target.value;
		let newValue = value;
		if(value.length === 6) {
			newValue = value.split('');
			this.char1.current.value = newValue[0].toUpperCase();
			this.char2.current.value = newValue[1].toUpperCase();
			this.char3.current.value = newValue[2].toUpperCase();
			this.char4.current.value = newValue[3].toUpperCase();
			this.char5.current.value = newValue[4].toUpperCase();
			this.char6.current.value = newValue[5].toUpperCase();
		} else {
			if(value.length > 1) {
				newValue = value.charAt(value.length - 1);
			}
			el.target.value = newValue.toUpperCase();
			if(el.target.parentElement.nextSibling) {
				el.target.parentElement.nextSibling.firstChild.focus();
			}
		}
	}

	importConfiguration(configuration) {
		const configurationItems = JSON.parse(configuration);
		configurationItems.forEach(configurationItem => {
			console.log('set id ' + configurationItem.id + ' to ' + configurationItem.value);

			if(document.getElementById(configurationItem.id)) {
				const element = document.getElementById(configurationItem.id);
				element.value = configurationItem.value;
				console.log(element.type);
				element.dispatchEvent(new Event('change', { bubbles: true }));

				const button = document.getElementById(element.value);
				if(button) {
					button.dispatchEvent(new Event('click', { bubbles: true }));
				}


				// if(configurationItem.id === 'background') {
				// 	this.props.setBackground(configurationItem.value);
				// }
			}

		});
	}

	fetchConfiguration() {
		const configurationCode = this.char1.current.value + this.char2.current.value + this.char3.current.value + this.char4.current.value + this.char5.current.value + this.char6.current.value;
		FetchData('/api/configuration/get/' + configurationCode, 'POST').then(result => {
			// console.log(result);
			if(result.response === 'error') {
				this.setState({error: true});
			}
			if(result.response === 'success') {
				this.setState({error: false}, () => {
					this.setState({imported: true});
					this.importConfiguration(result.configuration.configuration);
				});
			}
		});
	}

	componentDidMount() {
		this.char1.current.focus();
	}

	render() {

		const {error, imported} = this.state;

		return (
			<Fragment>
				<Aside title="Konfiguration importieren">
					<p>Hier kann mit einer Konfigurations-ID eine Markisenkonfiguration abgerufen werden.</p>

					<div className="d-block">

						{error &&
							<Fragment>
								<div className="alert alert-danger" role="alert">
									Diese Konfigurations-ID konnte nicht gefunden werden.
								</div>
							</Fragment>
						}

						{imported &&
							<Fragment>
								<div className="alert alert-success" role="alert">
									Ihre Konfiguration wurde geladen.
								</div>
							</Fragment>
						}

						{!imported &&
							<Fragment>
								<div className="row align-items-center my-3">
									<div className="col-2 text-center">
										<input ref={this.char1} type="text" className="form-control text-center" onChange={(p) => this.handleChange(p)} />
									</div>
									<div className="col-2 text-center">
										<input ref={this.char2} type="text" className="form-control text-center" onChange={(p) => this.handleChange(p)} />
									</div>
									<div className="col-2 text-center">
										<input ref={this.char3} type="text" className="form-control text-center" onChange={(p) => this.handleChange(p)} />
									</div>
									<div className="col-2 text-center">
										<input ref={this.char4} type="text" className="form-control text-center" onChange={(p) => this.handleChange(p)} />
									</div>
									<div className="col-2 text-center">
										<input ref={this.char5} type="text" className="form-control text-center" onChange={(p) => this.handleChange(p)} />
									</div>
									<div className="col-2 text-center">
										<input ref={this.char6} type="text" className="form-control text-center" onChange={(p) => this.handleChange(p)} />
									</div>
								</div>


								<button type="button" className="btn btn-outline-primary btn-lg w-100 d-block" onClick={() => this.fetchConfiguration()} >
									Importieren
								</button>
							</Fragment>
						}

					</div>
				</Aside>
			</Fragment>
		);
	}
}

export default Import;
